export default "__VITE_ASSET__d$kthNIh__"